import store from '@/store'
import network from '@/utils/network'
import { agencyPath } from '@/utils/api'

/**
 * Créé / met à jour un site
 * @returns {Promise<void>}
 */
export const postAgencyCustomerSite = async ({ customer, siteUsers, ...site }) => {
  const slugAgency = store.getters['user/agencySlug']
  const idCustomer = _.isObject(customer) ? customer.slug : customer
  const r = await network.post(`agency/${slugAgency}/customer/${idCustomer}/site`, {
    ...site,
    siteUsers: siteUsers
      ? siteUsers.map(({ agent = {}, ...siteUser }) => ({
        ...siteUser,
        site: site.id,
        agent: agent.id
      }))
      : undefined
  })
  return r.data
}

/**
 * Récupérer le matériel d'un site
 * @returns {Promise<void>}
 */
export const getAgencySiteItems = async ({ slug }) => {
  const r = await network.get(`${agencyPath()}/site/${slug}/items`)
  return r.data
}

/**
 * Créé / met à jour le matériel d'un site
 * @returns {Promise<void>}
 */
export const postAgencySiteItems = async ({ items = [], id, slug }) => {
  const r = await network.post(`${agencyPath()}/site/${slug}/items`, {
    id,
    items
  })
  return r.data
}

/**
 * Supprime un site
 * @returns {Promise<void>}
 */
export const deleteAgencyCustomerSite = async ({ customer, ...site }) => {
  const slugAgency = store.getters['user/agencySlug']
  const idCustomer = _.isObject(customer) ? customer.slug : customer
  const slugSite = site.slug
  const r = await network.delete(`agency/${slugAgency}/customer/${idCustomer}/site/${slugSite}`)
  return r.data
}
